import React from 'react';

import style from './info.module.scss';

export const Info = () => {
    return (
        <div className={style.info}>
            <div className={style.infoContact}>
                <div className={style.infoPhoneTitle}>Need to talk with a real person?</div>
                <button className={style.infoPhoneButton}>
                    <img alt="" src={process.env.PUBLIC_URL + '/assets/image/contact/calling.png'}></img>
                    <div className={style.buttonTitle}>Call 86-15369357369</div>
                </button>

                <div className={style.infoMailTitle}>Contact us via E-mail at</div>
                <a className={style.infoMailLink} href='mailto:sales@wintechseals.com'>
                    <img alt="" src={process.env.PUBLIC_URL + '/assets/image/contact/mail.png'}></img>
                    <div className={style.buttonTitle}>sales@wintechseals.com</div>
                </a>
            </div>

            <div className={style.infoAddress}>
                <div className={style.infoAddressTitle}>Address:</div>
                <div className={style.infoAddressValue}>No.6 Jingyue Street, Xinhua district, Shijiazhuang, Hebei</div>

                <div className={style.infoAddressTitle}>
                    Phone: <br />
                </div>
                <div className={style.infoAddressValue}>86-15369357369</div>
            </div>
        </div>
    );
};
